var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-block"},[_c('div',{staticClass:"logo__bg"}),_c('div',{staticClass:"stock__info"},[_vm._v("股票代码：300599")])])}]

export { render, staticRenderFns }